import 'es6-shim';
import 'zone.js';
import 'reflect-metadata';
import 'rxjs';
import 'lodash';

import '@angular/core';
import '@angular/forms';
import '@angular/common';
import '@angular/router';
import '@angular/http';
import '@angular/animations';
import '@angular/platform-browser';
import '@angular/platform-browser/animations';
import 'redux';
import 'redux-logger';
import 'redux-observable';

import '@angular-redux/store';

import 'chart.js';

import 'numeral';
import 'numeral/locales/pt-br';
import 'moment';
import 'moment/locale/pt-br';

import 'ng2-toastr/ng2-toastr';

import 'nouislider';
import 'ng2-nouislider';

import * as numeral from 'numeral';
import * as moment from 'moment';
numeral.locale('pt-br');
moment.locale('pt-br');


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./~/tslint-loader??ref--3!./app/vendor.ts